<select type="text" class="form-control " [(ngModel)]="value" (ngModelChange)="onChange($event)" [ngClass]="classes">
  <option disabled [ngValue]="null">{{placeholder}}</option>
  <option *ngFor=" let item of items$|async" [ngValue]="item">{{ item.name|titlecase }}</option>
</select>